import React, { useState } from 'react';
import styles from './style/back_hover_image_style.module.scss';

const BackHoverImage = ({ className, defaultSrc, hoverSrc }) => {
    function escapeAll(str) {
        return str && str
            .replace(/\(/g, '%28')
            .replace(/\)/g, '%29');
    }

    // console.log(new URL(escapeAll(hoverSrc)));

    return (
        <div className={`${className ? (className + ' ') : ''}${styles['back-hover-image']}`}>
            <div className={`${styles['image-a']} ${styles['image-container']}`}
                 style={{backgroundImage: `url(${escapeAll(defaultSrc)})`}}
            />
            <div className={`${styles['image-b']} ${styles['image-container']}`}
                 style={{backgroundImage: `url(${escapeAll(hoverSrc)})`}}
            />
        </div>
    );
};

export default BackHoverImage;
